<template>
  <div class="signup">
    <div class="signup__overlay">
      <div class="signup__content">
        <img src="../assets/img/login-logo.svg" alt="Logo" class="signup__logo">
        <h2 class="signup__title">Регистрация</h2>
        <form @submit.prevent="register">
          <div class="signup__inputWrapper" :class="{ 'error': emailError }">
            <input class="signup__input" type="email" v-model="email" required @focus="focused.email = true"
              @blur="focused.email = email !== ''" />
            <label :class="{ floating: focused.email || email !== '' }">Почта</label>
            <p v-if="emailError" class="error-message">{{ emailError }}</p>
          </div>
          <div class="signup__inputWrapper" :class="{ 'error': phoneError }">
            <input class="signup__input" type="text" v-model="phone" required @focus="focused.phone = true"
              @blur="focused.phone = phone !== ''" @input="formatPhone" />
            <label :class="{ floating: focused.phone || phone !== '' }">Номер телефона</label>
            <p v-if="phoneError" class="error-message">{{ phoneError }}</p>
          </div>
          <div class="signup__inputPair">
            <div class="signup__inputWrapper">
              <input class="signup__input" type="text" v-model="name" required @focus="focused.name = true"
                @blur="focused.name = name !== ''" />
              <label :class="{ floating: focused.name || name !== '' }">Имя</label>
            </div>
            <div class="signup__inputWrapper">
              <input class="signup__input" type="text" v-model="surname" required @focus="focused.surname = true"
                @blur="focused.surname = surname !== ''" />
              <label :class="{ floating: focused.surname || surname !== '' }">Фамилия</label>
            </div>
          </div>
          <div class="signup__inputWrapper" :class="{ 'error': passwordError }">
            <input class="signup__input" :type="showPassword ? 'text' : 'password'" v-model="password" required
              @focus="focused.password = true" @blur="focused.password = password !== ''" />
            <label :class="{ floating: focused.password || password !== '' }">Пароль</label>
            <span class="signup__togglePassword" @click="togglePasswordVisibility">
              <img :src="showPassword ? require('@/assets/img/eye-open.svg') : require('@/assets/img/eye-closed.svg')"
                alt="Toggle Password">
            </span>
          </div>
          <div class="signup__checkboxWrapper" :class="{ 'error': checkboxError }">
            <label class="signup__checkboxLabel">
              <input type="checkbox" v-model="agreement" />
              <span class="signup__checkboxCustom"></span>
            </label>
            <span>Я подтверждаю условия <a href="#">Пользовательского соглашения, Политики по персональным данным</a> и
              даю свое согласие на их обработку</span>
            <p v-if="checkboxError" class="error-message">Требуется подтвердить пользовательское соглашение</p>
          </div>

          <button class="signup__btn" type="submit" :class="{ 'signup__btn--loading': isRegistering }"
            :disabled="isRegistering">
            {{ isRegistering ? 'Уже регистрируемся...' : 'Зарегистрироваться' }}
          </button>
        </form>
        <p class="signup__subtitle">Уже есть аккаунт?</p>
        <button @click="this.$router.push('/login')" class="signup__link">&nbsp;Войти</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';

export default {
  name: 'SignupView',
  data() {
    return {
      email: '',
      name: '',
      surname: '',
      password: '',
      phone: '',
      showPassword: false,
      agreement: false,
      phone: '+7 ',
      focused: {
        email: false,
        name: false,
        surname: false,
        password: false,
        phone: false,
      },
      emailError: null,
      phoneError: null,
      passwordError: null,
      checkboxError: null,
      isRegistering: false,
    };
  },
  methods: {
    async register() {
      this.emailError = null;
      this.phoneError = null;
      this.passwordError = null;
      this.checkboxError = null;

      // Валидация телефона
      if (!this.validatePhone()) {
        return;
      }

      if (!this.agreement) {
        this.checkboxError = 'Требуется подтвердить пользовательское соглашение';
        return;
      }

      this.isRegistering = true;
      try {
        const emailHostPrefix = `${window.location.origin}/confirm`; // Динамически формируем emailHostPrefix

        const response = await axios.post('/api/pis/v1/user/signup', {
          email: this.email,
          name: this.name,
          surname: this.surname,
          password: this.password,
          phone: this.phone,
          emailHostPrefix
        });

        if (response.status === 200) {
          this.$router.push({
            path: '/confirm',
            query: { email: this.email } // Передаем email как параметр запроса
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const { email, password } = error.response.data;
          if (email) {
            this.emailError = email;
          }
          if (password) {
            this.passwordError = password;
          }
        }
        this.isRegistering = false;
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    formatPhone(event) {
      const input = event.target.value.replace(/\D/g, ''); // Убираем все нецифровые символы
      let formatted = '+7 ';
      if (input.length > 1) formatted += `(${input.slice(1, 4)}`;
      if (input.length >= 5) formatted += `) ${input.slice(4, 7)}`;
      if (input.length >= 8) formatted += ` ${input.slice(7, 9)}`;
      if (input.length >= 10) formatted += ` ${input.slice(9, 11)}`;
      this.phone = formatted; // Обновляем значение
    },
    validatePhone() {
      const phoneRegex = /^\+7 \(\d{3}\) \d{3} \d{2} \d{2}$/;
      if (!phoneRegex.test(this.phone)) {
        this.phoneError = 'Введите номер телефона в формате +7 (777) 777 77 77';
        return false;
      }
      this.phoneError = null;
      return true;
    },
  },

};
</script>
<style scoped>
.signup__btn--loading {
  background-color: #ccc;
  /* Измените цвет на ваш вкус */
  cursor: not-allowed;
}
</style>